import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../customComponents/CustomTable';
import downloadIcon from './../../../../../Assets/icons/download.svg';
import editIcon from './../../../../../Assets/icons/Un-Checkbox.svg';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API'; // Adjust this import path based on your project structure
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import { ToastContainer } from 'react-toastify';
import { toastSuccess } from '../../../../customComponents/customToast/Toast';
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import SearchInput from '../../../../customComponents/CustomSearch/SearchInput';
import Loader from '../../../../customComponents/CustomLoader';

const PublisherList = () => {
  const [publisherData, setPublisherData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [ totalData, setTotalData ] = useState(0)
  const [totalActive, setTotalActive] = useState(0)
  const [ totalInactive, setTotalInactive ] = useState(0)
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchPublisherData(newPage);
  };

  const fetchPublisherData = async (page = 0, pageSize =10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post('/publisher/list', {
        orderBy: 'publisher_id desc',
        page,
        pageSize,
        searchText:searchTerm
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1  
      }));

      const totalRecordsData = response?.data?.data?.totalRecords

      const totalCount = response?.data?.data?.total
      const totalAct = response?.data?.data?.total_active
      const totalInac = response?.data?.data?.total_inactive

      setTotalData(totalCount)
      setTotalActive(totalAct)
      setTotalInactive(totalInac)

      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);
      

      setPublisherData(formattedData);
     // toastSuccess("Product Data fetched successfully!"); 
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error('Error fetching publisher list:', error);
    }
    finally{
      setLoading(false)
    }
  };

  const TABLE_HEADERS = [
    // "Sr. No.",
    "Source Name",
    "Publisher Name",
    "Name",
    "Description",
    "Status",
    "Action"
  ];

  const keyMapping = {
    // "Sr. No.": "Sr No.",
    "Source Name":"source_name",
    "Publisher Name": "publisher_name",
    "Name": "publisher_name",
    "Description": "publisher_desc",
    "Status": "status",
    "Action": [
      { type: "edit", icon: editIcon, label: "Edit" },
    ]
  };

  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITPUBLISHER}`, { state: { data: rowData } });
   
  }
  useEffect(() => {
    if (searchTerm === "") {
      fetchPublisherData();
    }
  }, [searchTerm]);
  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
    <div>
        <div className='OnboardManagamentContainer'>
        <div className='OnboardManagamentbuttonContainer'>
        <h5>Publisher Management</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
        <div className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}} >
            <h5 className="listTopDataValueText" >{totalData} </h5>
            <h6>All Publisher</h6>
          </div>
          <div className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}} >
            <h5 className="listTopDataValueText" >{totalActive} </h5>
            <h6>Active Data</h6>
          </div>
          <div className='topleftdataContainer'>
            <h5 className="listTopDataValueText" >{totalInactive} </h5>
            <h6>Inactive Data</h6>
          </div>
          <button className='addcustomerbutton' onClick={() => navigate('/admin/manage-campaign/publisher/add-publisher')}>
          Add New Publisher
          </button>
        </div>
      </div>

      <div className='tableWrapper'>
        <div className='admin-list-container'>
        <div className='listsearchContainer'>
          <h5>Publisher List</h5>
          <div>
              <SearchInput
                placeholder="Search Publisher"
                onSearch={fetchPublisherData}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </div>
        
        </div>

        <CustomTable 
        data={publisherData} 
        headers={TABLE_HEADERS} 
        keyMapping={keyMapping}
        itemsPerPage={10}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onEdit={handleEdit} 
        totalRecords={totalRecords} 
        />
      </div>
    </div>
    )}
    </div>
  );
};

export default PublisherList;
